import { render, staticRenderFns } from "./principleApprovalTable.vue?vue&type=template&id=7f99d86e&"
import script from "./principleApprovalTable.vue?vue&type=script&lang=js&"
export * from "./principleApprovalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports